import { Illustration, Pictogram } from '@eti/components';
import { css, mediaQueries } from '@eti/styles';
import Media from 'react-media';
import { useDirection, useSiteContext } from '@eti/providers';
import { getProductIllustrationId, getProductPictogramId } from '../utils/icon/getProductImageryIds';
import { jsx as _jsx } from "react/jsx-runtime";
const pictogramStyles = css`
  margin-inline-end: 8px;
  margin-top: 2px;
`;
const DialogIllustration = _ref => {
  let {
    productName
  } = _ref;
  const {
    brand
  } = useSiteContext();
  const {
    isRTL
  } = useDirection();
  return /*#__PURE__*/_jsx(Media, {
    query: mediaQueries.small.only,
    children: isMobile => {
      var _getProductIllustrati;
      return isMobile ? /*#__PURE__*/_jsx(Pictogram, {
        brand: brand.code,
        className: pictogramStyles,
        height: 64,
        id: getProductPictogramId(productName, isRTL),
        mirrored: isRTL,
        width: 64
      }) : /*#__PURE__*/_jsx(Illustration, {
        brand: brand.code,
        id: (_getProductIllustrati = getProductIllustrationId(productName, isRTL)) !== null && _getProductIllustrati !== void 0 ? _getProductIllustrati : getProductIllustrationId('fallback', isRTL),
        mirrored: isRTL
      });
    }
  });
};
export default DialogIllustration;